import { render, staticRenderFns } from "./Riepilogo.vue?vue&type=template&id=a2b05cb6"
import script from "./Riepilogo.vue?vue&type=script&lang=js"
export * from "./Riepilogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports